import React, { ReactElement, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StudySiteDto } from '@interfaces/central-monitoring';

export interface SiteSelectorItem extends Omit<StudySiteDto, 'siteRef'> {
    favourite: boolean;
    _isDefault: boolean;
}

interface StudySelectorListItemProps {
    li: ReactElement<HTMLLIElement>;
    dataItem: SiteSelectorItem;
}

export const StudySiteSelectorListItem = ({ li, dataItem }: StudySelectorListItemProps) => {
    const itemChildren = (
        <div className="k-display-flex k-w-full k-align-items-center k-justify-content-between">
            {li.props.children as Iterable<ReactNode>}
            <div className="icons-wrapper">
                {dataItem._isDefault && <FontAwesomeIcon icon={['far', 'asterisk']} className="asterisk" />}
                {dataItem.favourite && <FontAwesomeIcon icon={['fas', 'star']} />}
            </div>
        </div>
    );

    return React.cloneElement(li, li.props, itemChildren);
};
